<template>
  <div v-if="educations.length > 0 || languages.length > 0" class="extra-education-component">
    <h2>
      {{ $t('ETAB.PAGES.EXTRA.@EDUCATION_TITLE') }}
    </h2>
    <!-- Education -->
    <IconBoxWrapper
v-if="educations.length > 0"
                    borderless
                    icon-background="primary"
                    icon="icon-extra-diploma"
                    icon-color="white"
                    icon-size="25px"
                    radius
                    shadow
    >
      <article>
        <section
v-for="(education, index) in educations"
                 :key="education.getId()+'_'+index"
        >
          <h4>{{ education.getTitle() }}</h4>
          <p>{{ education.getLabel() }}</p>
          <p>{{ education.getPeriod() }}</p>
        </section>
      </article>
    </IconBoxWrapper>
    <!-- Language -->
    <IconBoxWrapper
v-if="languages.length > 0"
                    borderless
                    icon-background="primary"
                    icon="icon-f-globe"
                    icon-color="white"
                    icon-size="25px"
                    radius
                    shadow
    >
      <article>
        <section
v-for="(language, index) in languages"
                 :key="language.getId()+'_'+index"
        >
          <h4>{{ language.getLabel() }}</h4>
          <p>{{ language.getLevel() }}</p>
        </section>
      </article>
    </IconBoxWrapper>
  </div>
</template>

<script>
import { ExtraModel } from "@core/models";

export default {
  props: {
    extra: {
      type: Object,
      default: () => new ExtraModel(),
    },
  },
  computed: {
    educations() {
      return this.extra.getEducation() || [];
    },
    languages() {
      return this.extra.getLanguages() || [];
    },
  },
};
</script>

<style lang="scss">
.extra-education-component {
  margin-top: 35px;
  color: $primary;

  h2 {
    margin: 0;
  }

  .extra-icon-box-wrapper {
    margin: 25px 0;
  }

  article {
    padding: 0 15px;

    > section {
      margin: 15px 0;

      h4 {
        line-height: 1.25;
        font-weight: bold;
        color: $primary;
        margin: 5px;
      }

      p {
        line-height: 1.25;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 5px;
        color: $grey;
      }
    }
  }
}
</style>
